import { Component, OnDestroy, Output, EventEmitter, input } from '@angular/core';
import { SearchModel } from './model';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface ISearchForm {
  searchQuery: FormControl<string>;
}

@Component({
  selector: 'adm-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule],
})
export class SearchComponent implements OnDestroy {
  placeholder = input<string>('');
  labelText = input<string>('Søg');
  query = input<string>('');

  @Output()
  searchEvent = new EventEmitter<SearchModel>();

  searchModel: SearchModel = {};

  get searchQuery() {
    return this.form.controls.searchQuery;
  }

  form = new FormGroup<ISearchForm>({
    searchQuery: new FormControl<string>(this.query(), { nonNullable: true }),
  });

  constructor() {
    this.form.valueChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntilDestroyed()).subscribe(value => {
      this.searchModel = value as SearchModel;
      this.searchEvent.emit(this.searchModel);
    });
  }

  ngOnDestroy() {
    this.searchEvent.complete();
  }

  clearSearch() {
    this.form.controls.searchQuery.setValue('');
  }
}
